import { render, staticRenderFns } from "./TextareaParser.vue?vue&type=template&id=2587676e&scoped=true&"
import script from "./TextareaParser.vue?vue&type=script&lang=js&"
export * from "./TextareaParser.vue?vue&type=script&lang=js&"
import style0 from "./TextareaParser.vue?vue&type=style&index=0&id=2587676e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2587676e",
  null
  
)

export default component.exports